import { Link, useNavigate } from 'react-router'

import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { TableCell, TableRow } from '@/components/ui/table'
import { CUSTOMER_FILL_APPLICATION_TAB, customerTabHref } from '@/lib/customerTabs'
import { formatDateTimeShort } from '@/lib/formatters'
import { type RequoteRequestRow, RequoteRequestStatus } from '@/models/requoteRequest'
import { RequoteChangesDialog } from '../../Customers/RequoteChangesDialog'

const STATUS_BADGES: Record<RequoteRequestStatus, { label: string; variant: BadgeVariant }> = {
  [RequoteRequestStatus.WAITING]: { label: 'Waiting', variant: 'warning' },
  [RequoteRequestStatus.REQUOTED]: { label: 'Re-quoted', variant: 'secondary' },
}

function Blank() {
  return <span className="text-muted-foreground">—</span>
}

/** Opens the customer's Intake tab, where staff change the answers and re-quote. */
export function RequoteRow({ row }: { row: RequoteRequestRow }) {
  const navigate = useNavigate()
  const href = customerTabHref(row.orgId, CUSTOMER_FILL_APPLICATION_TAB)
  const status = STATUS_BADGES[row.status]

  return (
    <TableRow className="cursor-pointer" onClick={() => navigate(href)}>
      <TableCell className="font-medium">
        <Link to={href} className="rounded-sm hover:underline" onClick={(e) => e.stopPropagation()}>
          {row.orgName}
        </Link>
      </TableCell>
      <TableCell>{row.requestedBy ?? <Blank />}</TableCell>
      <TableCell>{formatDateTimeShort(row.dateRequested)}</TableCell>
      <TableCell className="text-right">{row.requestCount}</TableCell>
      <TableCell>{row.salesOwner ?? <Blank />}</TableCell>
      <TableCell>
        <Badge variant={status.variant}>{status.label}</Badge>
      </TableCell>
      {/* The dialog renders in a portal, but React still bubbles its clicks to the row. */}
      <TableCell onClick={(e) => e.stopPropagation()}>
        {row.changes.length > 0 ? <RequoteChangesDialog changes={row.changes} /> : <Blank />}
      </TableCell>
    </TableRow>
  )
}
